import { Bell, PanelLeftClose, PanelLeftOpen, Search, X } from "lucide-react";

import { FeatureFlag } from "@/components/FeatureFlag";
import { cn } from "@/lib/utils";

const RAIL_BUTTON =
  "text-rail-item hover:bg-rail-hover hover:text-rail-foreground rounded-chip relative grid size-9 shrink-0 cursor-pointer place-items-center";

interface SidebarHeaderProps {
  tenantName: string;
  compact: boolean;
  onToggleCompact: () => void;
  /** Solo en móvil: cierra el menú desplegado. */
  onClose?: (() => void) | undefined;
}

export function SidebarHeader({
  tenantName,
  compact,
  onToggleCompact,
  onClose,
}: SidebarHeaderProps) {
  return (
    <>
      <div
        className={cn(
          "border-rail-border flex border-b px-4",
          compact ? "flex-col items-center gap-2 px-2 py-3" : "h-16 items-center gap-2.5",
        )}
      >
        <img
          // Clara es el producto y es la agente que atiende: su cara es el distintivo.
          src="/clara.jpg"
          alt=""
          aria-hidden
          width={64}
          height={64}
          className="size-9 shrink-0 rounded-full object-cover"
        />
        {!compact && (
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-semibold">Clara</p>
            <p className="text-rail-muted truncate text-xs">{tenantName}</p>
          </div>
        )}
        <FeatureFlag name="notifications">
          {/* El aviso de no leídos llega con `GET /me/notifications`. */}
          <button type="button" aria-label="Avisos" className={RAIL_BUTTON}>
            <Bell aria-hidden strokeWidth={1.75} className="size-[17px]" />
          </button>
        </FeatureFlag>
        {onClose ? (
          <button
            type="button"
            aria-label="Cerrar menú"
            onClick={onClose}
            className={cn(RAIL_BUTTON, "lg:hidden")}
          >
            <X aria-hidden strokeWidth={1.75} className="size-[17px]" />
          </button>
        ) : null}
        <button
          type="button"
          onClick={onToggleCompact}
          aria-label={compact ? "Expandir menú" : "Colapsar menú"}
          aria-expanded={!compact}
          className={cn(RAIL_BUTTON, "hidden lg:grid")}
        >
          {compact ? (
            <PanelLeftOpen aria-hidden strokeWidth={1.75} className="size-[17px]" />
          ) : (
            <PanelLeftClose aria-hidden strokeWidth={1.75} className="size-[17px]" />
          )}
        </button>
      </div>

      <FeatureFlag name="commandSearch">
        {!compact && (
          <div className="px-2.5 pt-3 pb-1">
            <button
              type="button"
              className="border-rail-border hover:bg-rail-hover rounded-chip bg-rail-hover/50 text-rail-item flex h-10 w-full cursor-pointer items-center gap-2.5 border px-3 text-[13px]"
            >
              <Search aria-hidden strokeWidth={1.75} className="size-[15px]" />
              <span className="flex-1 text-left">Buscar o hacer algo…</span>
              <kbd className="bg-rail-hover rounded-tag px-1.5 py-0.5 font-mono text-[11px]">
                ⌘K
              </kbd>
            </button>
          </div>
        )}
      </FeatureFlag>
    </>
  );
}
